import React from 'react'

const SOCIAL_LINKS = [
    { key: 'website', label: '官网', icon: 'fas fa-globe' },
    { key: 'twitter', label: '推特', icon: 'fab fa-twitter' },
    { key: 'telegram', label: 'Telegram', icon: 'fab fa-telegram' },
    { key: 'youtube', label: 'Youtube', icon: 'fab fa-youtube' },
    { key: 'discord', label: 'Discord', icon: 'fab fa-discord' },
    { key: 'github', label: 'Github', icon: 'fab fa-github' },
    { key: 'reddit', label: 'Reddit', icon: 'fab fa-reddit-alien' },
    { key: 'facebook', label: 'Facebook', icon: 'fab fa-facebook' },
]

export function normalizeExternalLink(value, type) {
    const rawValue = String(value || '').trim()
    if (!rawValue || /^(?:javascript|data|vbscript):/i.test(rawValue)) return ''

    let candidate = rawValue
    if (rawValue.startsWith('//')) {
        candidate = `https:${rawValue}`
    } else if (!/^https?:\/\//i.test(rawValue)) {
        const handle = rawValue.replace(/^@/, '')
        const isPlainHandle = !/[./]/.test(handle)
        if (type === 'telegram' && (rawValue.startsWith('@') || isPlainHandle)) candidate = `https://t.me/${handle}`
        else if (type === 'twitter' && (rawValue.startsWith('@') || isPlainHandle)) candidate = `https://x.com/${handle}`
        else candidate = `https://${rawValue}`
    }

    try {
        const parsed = new URL(candidate)
        return ['http:', 'https:'].includes(parsed.protocol) ? parsed.toString() : ''
    } catch (error) {
        return ''
    }
}

export default function SocialLinks({ ipfsInfo = {}, t = (key) => key }) {
    const links = SOCIAL_LINKS.map((item) => ({
        ...item,
        href: normalizeExternalLink(ipfsInfo[item.key], item.key),
    })).filter((item) => item.href)

    if (links.length === 0) return null

    return <nav className="console-social-links" aria-label={t('项目链接')}>
            {links.map((link) => <a key={link.key} href={link.href} target="_blank" rel="noopener noreferrer" aria-label={t(link.label)} title={t(link.label)}>
                <i className={link.icon} aria-hidden="true" />
            </a>)}
    </nav>
}
